(() => {
  const TZ = 'Europe/Berlin';
  const START_MIN = 4 * 60; // einblenden ab 04:00
  const END_MIN = 9 * 60; // ausblenden ab 09:00

  const berlinMinutes = () => {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: TZ,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      const hour = Number(parts.find((p) => p.type === 'hour')?.value);
      const minute = Number(parts.find((p) => p.type === 'minute')?.value);
      if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;
      return hour * 60 + minute;
    } catch (_) {
      const d = new Date();
      return d.getHours() * 60 + d.getMinutes();
    }
  };

  const isHappyHour = () => {
    const mins = berlinMinutes();
    return mins != null && mins >= START_MIN && mins < END_MIN;
  };

  const sync = () => {
    const active = isHappyHour();
    document.querySelectorAll('[data-ysf-happy-hour]').forEach((el) => {
      if (active) {
        el.removeAttribute('hidden');
        el.classList.add('ysf-happy-hour--active');
      } else {
        el.setAttribute('hidden', '');
        el.classList.remove('ysf-happy-hour--active');
      }
    });
  };

  const init = () => {
    sync();
    // Zur vollen Minute neu prüfen (Wechsel 04:00 / 09:00)
    const now = new Date();
    const msToNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
    setTimeout(() => {
      sync();
      setInterval(sync, 60 * 1000);
    }, Math.max(msToNextMinute, 0));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
